import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import PrivateRoute from './PrivateRoute'

import Homepage from './Homepage'
import Header from './Components/goma/Header';
import Login from './Components/goma/Login';
import SingleSignOn from './Components/goma/SingleSignOn';
import LoginSplash from './Components/goma/LoginSplash';
import ForgotPassword from './Components/goma/ForgotPassword';
import ResetPassword from './Components/goma/ResetPassword';
import ExhibitorDetails from './Components/goma/Exhibitor/ExhibitorDetails';
import ExhibitorBooth from './Components/goma/Exhibitor/ExhibitorBooth';

import Dashboard from './Components/goma/Exhibitor/Dashboard';
import Lobby from './Components/goma/Attendee/Lobby';
import ExhibitHall from './Components/goma/Attendee/ExhibitHall';
import NetworkingLounge from './Components/goma/Attendee/NetworkingLounge';
import ConferenceCenter from './Components/goma/Attendee/ConferenceCenter';
import ConferenceCenterPage from './Components/goma/Attendee/ConferenceCenterPage';
import TechnicalSessions from './Components/goma/Attendee/TechnicalSessions';
import ExhibitList from './Components/goma/Attendee/ExhibitList';

import HelpDesk from './Components/goma/Attendee/HelpDesk';
import GoldenTicket from './Components/goma/Attendee/GoldenTicket';
import AttendeeExhibitorBooth from './Components/goma/Attendee/AttendeeExhibitorBooth';
import NotFound from './Components/goma/NotFound';

import DashboardSpeaker from './Components/goma/Speaker/Dashboard';
import ProfileDetails from './Components/goma/Speaker/ProfileDetails';
import SessionAttendees from './Components/goma/Speaker/SessionAtendees';
import UserProfile from './Components/goma/UserProfile';

import ChatPage from "./TmChat/goma/chat/ChatPage";
import VideoCall from "./TmChat/goma/video/VideoCall";
import ConferenceMeeting from "./TmChat/goma/videoConference/conferenceMeeting";
import Meetings from "./TmChat/goma/videoConference/meetings";
import WorkProgress from './Components/goma/WorkProgress';

/* import test from './Components/goma/Exhibitor/test'; */

class Goma extends Component {
constructor(){
  super();

  this.state={
    homePage:""
  }
}


  render() {

    const domain = window.location.href
    if(domain === ("http://localhost:3000/" || "https://affectionate-bohr-4d306b.netlify.app/")){
      return(
        <div className="App">
            <Router>
              <Route path="/" exact component={Homepage} />
              {/* <Route path="/home" exact component={Homepage} /> */}
            </Router>
        </div>
      )
    }
    else {
      return (
      <Router>
          <div className="App">
            
            <Header/>
            <Switch>
                
                <Route path="/goma/login/:loginId" exact component={Login} />
                <PrivateRoute path="/goma/loginSplash" exact component={LoginSplash} />
                <Route path="/goma/single-signon/:eventId/:emailId/:tokenpass" exact component={SingleSignOn} />
                <Route path="/goma/forgotPassword" component={ForgotPassword} />
                <Route path="/goma/resetPassword" component={ResetPassword} />
                <PrivateRoute path="/goma/chat" exact component={ChatPage} />
                <PrivateRoute path="/goma/video-call" exact component={VideoCall} />
                <PrivateRoute path="/goma/video-conference" exact component={Meetings} />
                <PrivateRoute path="/goma/conference-meeting/:id" exact component={ConferenceMeeting} />
                <PrivateRoute path="/goma/exhibitor/dashboard" exact component={Dashboard} />
                <PrivateRoute path="/goma/exhibitor/profile" exact component={ExhibitorDetails} />
                <PrivateRoute path="/goma/exhibitor/booth" component={ExhibitorBooth} />
                <PrivateRoute path="/goma/attendee/lobby" component={Lobby} />
                <PrivateRoute path="/goma/attendee/exhibitHall" component={ExhibitHall} />
                <PrivateRoute path="/goma/attendee/networkingLounge" component={NetworkingLounge} />
                <PrivateRoute path="/goma/attendee/conferenceCenter" component={ConferenceCenter} />
                <PrivateRoute path="/goma/attendee/conferenceCenterDetails/:sessionId" component={ConferenceCenterPage} />
                <PrivateRoute path="/goma/attendee/technicalSessions" component={TechnicalSessions} />
                <PrivateRoute path="/goma/attendee/exhibitList" component={ExhibitList} />
                <PrivateRoute path="/goma/attendee/helpDesk" component={HelpDesk} />
                <PrivateRoute path="/goma/attendee/goldenTicket" component={GoldenTicket} />
                <PrivateRoute path="/goma/attendee/exhibitorBooth/:exhibitorId" component={AttendeeExhibitorBooth} />
                <PrivateRoute path="/goma/speaker/dashboard" exact component={DashboardSpeaker} />
                <PrivateRoute path="/goma/speaker/profile" exact component={ProfileDetails} />
                <PrivateRoute path="/goma/speaker/attendees" exact component={SessionAttendees} />
                <PrivateRoute path="/goma/user/profile" exact component={UserProfile} />
                <Route path="/goma/workProgress" exact component={WorkProgress} />
                <Route path="*" component={NotFound} />
              </Switch>
         
          </div>
      </Router>
    );}
  }  
}

export default Goma;
